class AppId {
  private constructor(public appId: string) {}

  static from(appId: string): AppId {
    return new AppId(appId);
  }

  get authorizationEndpoint(): string {
    return `https://login.microsoftonline.com/${this.appId}/oauth2/v2.0/authorize`;
  }
  get issuer(): string {
    return `https://login.microsoftonline.com/${this.appId}/v2.0`;
  }

  get openIdDocument(): string {
    return `https://login.microsoftonline.com/${this.appId}/v2.0/.well-known/openid-configuration`;
  }
}

export const APP_ID = AppId.from('906aefe9-76a7-4f65-b82d-5ec20775d5aa'); // same as Gibbon
